//Uses PasswordRecovery.js to create the full password recovery page.
import React from 'react';
import PasswordRecovery from '../components/PasswordRecovery'; // Import the reusable PasswordRecovery component
import '../App.css'; // Import external CSS file for styling

function PasswordRecoveryPage() {
    return (
        <div className="password-recovery-page">
            <h1>Восстановление пароля</h1>
            <p>Введите ваш e-mail для восстановления пароля:</p>
            <PasswordRecovery /> {/* Embed the reusable PasswordRecovery component */}
        </div>
    );
}

export default PasswordRecoveryPage;
